/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../simple_instrument_store/model';
import '../instant-deposit/instant_deposits';
import './api';
import '../common/time';
import '../common/currency';
import '../cash/checkmate/api/CheckDepositProto';
import '../cash/gambit/api/v1/checkdeposit/check_deposit';
import '../teller/teller';
import '../checkbook/data';
import '../payments/push_money';
import '../bookkeeper/bookkeeper';
import '../connect/v2/resources/error';
import '../bankc/result';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "deposits": {
        "nested": {
          "EligibilityBlocker": {
            "values": {
              "UNKNOWN": 0,
              "NOT_ONBOARDED": 1,
              "NO_FUNDING_SOURCE": 2,
              "INSUFFICIENT_FUNDS": 3,
              "UNSETTLEABLE": 4,
              "OVER_DEPOSIT_LIMIT": 5,
              "NOT_APPROVED": 6,
              "EXCEEDS_DEPOSIT_LIMIT": 7,
              "NO_BANK_ACCOUNT": 8,
              "UNVERIFIED_FUNDING_SOURCE": 9,
              "INSUFFICIENT_PAYMENT_ACTIVITY": 10,
              "FUNDING_SOURCE_VERIFICATION_EXPIRED": 11,
              "FUNDING_SOURCE_UNSUPPORTED": 12,
              "INSTANT_DEPOSIT_UNAVAILABLE": 13,
              "OVER_DAILY_DEPOSIT_LIMIT": 14,
              "INVALID_UNIT": 15,
              "FEE_CURRENCY_MISMATCH": 16,
              "BLOCKED_BY_RISK": 17,
              "MERCHANT_MISMATCH": 18,
              "OVER_WEEKLY_DEPOSIT_LIMIT": 19,
              "TEMPORARY_OUTAGE": 20,
              "OVER_MONTHLY_DEPOSIT_LIMIT": 21
            }
          },
          "Balance": {
            "fields": {
              "balanceId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "balanceType": {
                "type": ".squareup.deposits.BalanceType",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "BalanceActivityType": {
            "values": {
              "DO_NOT_USE": 0,
              "DEBIT_CARD_PAY_IN": 1,
              "SAME_DAY_PAYOUT": 2,
              "STANDARD_SPEED_PAYOUT": 3,
              "INSTANT_PAYOUT": 4,
              "DEBIT_CARD_PAY_IN_CHARGEBACK": 5,
              "CHECK_PAY_IN": 6,
              "CHECK_PAY_OUT": 15,
              "BALANCE_TRANSFER": 7,
              "DIRECT_DEPOSIT_IN": 8,
              "DIRECT_DEPOSIT_OUT": 9,
              "SUBSCRIPTIONS": 10,
              "SUBSCRIPTIONS_REFUND": 14,
              "PAYROLL_INSTANT_PAYOUT": 11,
              "BILL_PAYMENT": 12,
              "BALANCE_TRANSFER_CHARGEBACK": 13
            }
          },
          "BalanceActivityEntityIdentifier": {
            "fields": {
              "instrumentToken": {
                "type": "string",
                "id": 1
              },
              "unitToken": {
                "type": "string",
                "id": 2
              },
              "balanceId": {
                "type": "string",
                "id": 3
              },
              "pendingEntity": {
                "type": ".squareup.deposits.BalanceActivityEntityIdentifier.PendingEntity",
                "id": 4
              },
              "issuedCheck": {
                "type": ".squareup.deposits.BalanceActivityEntityIdentifier.IssuedCheck",
                "id": 5
              },
              "accountId": {
                "type": "string",
                "id": 6
              }
            },
            "nested": {
              "IssuedCheck": {
                "fields": {
                  "memo": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "payeeName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "checkNonce": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PendingEntity": {
                "fields": {}
              },
              "entity_identifier": {
                "oneof": ["instrumentToken", "unitToken", "balanceId", "pendingEntity", "issuedCheck", "accountId"]
              }
            }
          },
          "BalanceActivityEntityView": {
            "fields": {
              "instrument": {
                "type": ".squareup.deposits.InstrumentView",
                "id": 1
              },
              "unitToken": {
                "type": "string",
                "id": 2
              },
              "balance": {
                "type": ".squareup.deposits.Balance",
                "id": 3
              }
            },
            "nested": {
              "entity_identifier": {
                "oneof": ["instrument", "unitToken", "balance"]
              }
            }
          },
          "BalanceActivityEntityType": {
            "values": {
              "UNKNOWN_ENTITY_TYPE_DO_NOT_USE": 0,
              "BALANCE": 1,
              "CARD": 2,
              "BANK": 3,
              "CHECK": 4,
              "SQ_INTERNAL_PLATFORM": 5,
              "BANKC_BALANCE": 6,
              "ISSUED_CHECK": 7,
              "PENDING_ENTITY": 8,
              "FOLDER_ACCOUNT_BALANCE": 9,
              "SAVINGS_BANK_ACCOUNT_BALANCE": 10
            }
          },
          "InstrumentView": {
            "fields": {
              "instrumentToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "autoInstantDepositToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "cardPanSuffix": {
                "type": "string",
                "id": 2
              },
              "bankAccountNumberSuffix": {
                "type": "string",
                "id": 3
              },
              "cardSummary": {
                "type": ".squareup.deposits.InstrumentView.CardSummary",
                "id": 4
              },
              "bankAccountSummary": {
                "type": ".squareup.deposits.InstrumentView.BankAccountSummary",
                "id": 5
              },
              "checkSummary": {
                "type": ".squareup.deposits.InstrumentView.CheckSummary",
                "id": 6
              },
              "issuedCheckSummary": {
                "type": ".squareup.deposits.InstrumentView.IssuedCheckSummary",
                "id": 8
              }
            },
            "nested": {
              "CardSummary": {
                "fields": {
                  "panSuffix": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "brand": {
                    "type": ".squareup.simple_instrument_store.Brand",
                    "id": 2,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.ledger.service.GetInstantDepositAccountResponse.CardStatus",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "BankAccountSummary": {
                "fields": {
                  "accountNumberSuffix": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "bankName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.deposits.BankAccountInfo.BankAccountState",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CheckSummary": {
                "fields": {
                  "checkMetadata": {
                    "type": ".squareup.deposits.CheckMetadata",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "IssuedCheckSummary": {
                "fields": {
                  "printableCheckId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": ".squareup.deposits.CheckMetadata.CheckTransferOutMetadata",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "instrument_number_view": {
                "oneof": ["cardPanSuffix", "bankAccountNumberSuffix"]
              },
              "instrument_summary": {
                "oneof": ["cardSummary", "bankAccountSummary", "checkSummary", "issuedCheckSummary"]
              }
            }
          },
          "TransferBankAccountEntity": {
            "fields": {
              "instrumentToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "accountNumberSuffix": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "bankName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              },
              "verificationStatus": {
                "type": ".squareup.deposits.TransferEntityVerificationState",
                "id": 6,
                "rule": "optional"
              },
              "encodedSqwebBankToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "TransferCardEntity": {
            "fields": {
              "instrumentToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "panSuffix": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "cardBrand": {
                "type": ".squareup.simple_instrument_store.Brand",
                "id": 3,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "updatedAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              },
              "verificationStatus": {
                "type": ".squareup.deposits.TransferEntityVerificationState",
                "id": 6,
                "rule": "optional"
              }
            }
          },
          "AvailableBankAction": {
            "values": {
              "UNKNOWN_AVAILABLE_BANK_ACTION_DO_NOT_USE": 0,
              "LINK_BANK_ACCOUNT_ACTION": 1
            }
          },
          "AvailableCardAction": {
            "values": {
              "UNKNOWN_AVAILABLE_CARD_ACTION_DO_NOT_USE": 0,
              "LINK_DEBIT_CARD_ACTION": 1
            }
          },
          "AvailableInstrumentAction": {
            "values": {
              "UNKNOWN_AVAILABLE_INSTRUMENT_ACTION_DO_NOT_USE": 0,
              "LINK_BANK_ACCOUNT": 1,
              "LINK_DEBIT_CARD": 2,
              "RESEND_VERIFICATION": 3,
              "CANCEL_VERIFICATION": 4
            }
          },
          "TransferEntityVerificationState": {
            "values": {
              "TRANSFER_ENTITY_VERIFICATION_STATE_DO_NOT_USE": 0,
              "VERIFIED": 1,
              "PENDING_VERIFICATION": 2,
              "AWAITING_2FA_CONFIRMATION": 3,
              "FAILED_VERIFICATION": 4,
              "CANCELLED_VERIFICATION": 5,
              "VERIFICATION_EXPIRED": 6
            }
          },
          "BalanceActivity": {
            "fields": {
              "source": {
                "type": ".squareup.deposits.BalanceActivityEntityView",
                "id": 1,
                "rule": "optional"
              },
              "destination": {
                "type": ".squareup.deposits.BalanceActivityEntityView",
                "id": 2,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 19,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 21,
                "rule": "optional"
              },
              "amount": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "feeAmount": {
                "type": ".squareup.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "feeStructure": {
                "type": ".squareup.ledger.service.FeeStructure",
                "id": 5,
                "rule": "optional"
              },
              "type": {
                "type": ".squareup.deposits.BalanceActivityType",
                "id": 6,
                "rule": "optional"
              },
              "token": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 8,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.deposits.BalanceActivity.State",
                "id": 9,
                "rule": "optional"
              },
              "paginationToken": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "syncId": {
                "type": "int64",
                "id": 11,
                "rule": "optional"
              },
              "balanceType": {
                "type": ".squareup.deposits.BalanceType",
                "id": 12,
                "rule": "optional"
              },
              "clientIp": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "externalToken": {
                "type": "string",
                "id": 14,
                "rule": "optional"
              },
              "failure": {
                "type": ".squareup.deposits.BalanceActivityFailure",
                "id": 15,
                "rule": "optional"
              },
              "shouldEvaluateForRiskAssessment": {
                "type": "bool",
                "id": 16,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "updatedAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 17,
                "rule": "optional"
              },
              "externalTransferTraceInfo": {
                "type": ".squareup.deposits.ExternalTransferTraceInfo",
                "id": 18,
                "rule": "repeated"
              },
              "balanceActivityEntryType": {
                "type": ".squareup.deposits.BalanceActivityEntryType",
                "id": 20,
                "rule": "optional"
              },
              "metadata": {
                "type": ".squareup.deposits.TransferMetadata",
                "id": 22,
                "rule": "optional"
              },
              "pull": {
                "type": ".squareup.deposits.SweepData",
                "id": 23,
                "rule": "optional"
              },
              "push": {
                "type": ".squareup.deposits.SweepData",
                "id": 24,
                "rule": "optional"
              },
              "rollback": {
                "type": ".squareup.deposits.SweepData",
                "id": 25,
                "rule": "optional"
              }
            },
            "nested": {
              "State": {
                "values": {
                  "PENDING": 0,
                  "SUCCEEDED": 1,
                  "FAILED": 2,
                  "REVERSED": 3,
                  "SENT": 4
                }
              }
            }
          },
          "BalanceActivityEntryType": {
            "values": {
              "UNKNOWN_BALANCE_ACTIVITY_ENTRY_TYPE_DO_NOT_USE": 0,
              "CREDIT": 1,
              "DEBIT": 2
            }
          },
          "ExternalTransferTraceInfo": {
            "fields": {
              "type": {
                "type": ".squareup.deposits.ExternalTransferTraceInfo.TraceInfoType",
                "id": 1,
                "rule": "optional"
              },
              "value": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "TraceInfoType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "ACH_TRACE_NUMBER": 1,
                  "TRANSMISSION_ID": 2,
                  "END_TO_END_ID": 3,
                  "RRN_NUMBER": 4
                }
              }
            }
          },
          "CheckMetadata": {
            "fields": {
              "frontImageTrunkToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "backImageTrunkToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "transferOutMetadata": {
                "type": ".squareup.deposits.CheckMetadata.CheckTransferOutMetadata",
                "id": 5,
                "rule": "optional"
              },
              "transferInMetadata": {
                "type": ".squareup.deposits.CheckMetadata.CheckTransferInMetadata",
                "id": 7,
                "rule": "optional"
              },
              "checkmateCheckDeposit": {
                "type": ".squareup.cash.checkmate.service.CheckDeposit",
                "id": 4
              },
              "gambitCheckDeposit": {
                "type": ".squareup.cash.gambit.api.v1.checkdeposit.CheckDeposit",
                "id": 6
              }
            },
            "nested": {
              "CheckTransferOutMetadata": {
                "fields": {
                  "payeeName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "memo": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "checkNonce": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CheckTransferInMetadata": {
                "fields": {
                  "partialFundingMetadata": {
                    "type": ".squareup.deposits.CheckMetadata.CheckTransferInMetadata.PartialFundingMetadata",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PartialFundingMetadata": {
                    "fields": {
                      "originalDepositAmount": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "partialDepositAmount": {
                        "type": ".squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "remainderDepositAmount": {
                        "type": ".squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "partialDepositTransactionId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "remainderDepositTransactionId": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "partialFundedAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 6,
                        "rule": "optional"
                      },
                      "remainderEstimatedBy": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 7,
                        "rule": "optional"
                      },
                      "remainderFundedAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 8,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "check_deposit": {
                "oneof": ["checkmateCheckDeposit", "gambitCheckDeposit"]
              }
            }
          },
          "BalanceActivityFailureMetadata": {
            "fields": {
              "expectedBalance": {
                "type": ".squareup.common.Money",
                "id": 1,
                "rule": "optional"
              },
              "sweepFailureReason": {
                "type": ".squareup.deposits.SweepFailureReason",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "BalanceActivityFailure": {
            "fields": {
              "eligibilityBlocker": {
                "type": ".squareup.deposits.EligibilityBlocker",
                "id": 1,
                "rule": "optional"
              },
              "moneyMovingBlocker": {
                "type": ".squareup.ledger.service.MoneyMovingBlocker",
                "id": 2,
                "rule": "optional"
              },
              "failureMetadata": {
                "type": ".squareup.deposits.BalanceActivityFailureMetadata",
                "id": 3,
                "rule": "optional"
              },
              "transferFailure": {
                "type": ".squareup.deposits.BalanceActivityFailure.TransferFailure",
                "id": 4,
                "rule": "optional"
              }
            },
            "nested": {
              "TransferFailure": {
                "fields": {
                  "internalFailure": {
                    "type": ".squareup.deposits.BalanceActivityFailure.TransferFailure.InternalFailure",
                    "id": 1
                  },
                  "eligibilityBlocker": {
                    "type": ".squareup.deposits.EligibilityBlocker",
                    "id": 2
                  },
                  "bankFailure": {
                    "type": ".squareup.deposits.BalanceActivityFailure.TransferFailure.BankFailure",
                    "id": 3
                  },
                  "cardFailure": {
                    "type": ".squareup.deposits.BalanceActivityFailure.TransferFailure.CardFailure",
                    "id": 4
                  },
                  "balanceFailure": {
                    "type": ".squareup.deposits.BalanceActivityFailure.TransferFailure.BalanceFailure",
                    "id": 5
                  },
                  "checkFailure": {
                    "type": ".squareup.deposits.BalanceActivityFailure.TransferFailure.CheckFailure",
                    "id": 6
                  }
                },
                "nested": {
                  "InternalFailure": {
                    "values": {
                      "INTERNAL_TRANSFER_FAILURE_DO_NOT_USE": 0,
                      "INTERNAL_FATAL_FAILURE": 1
                    }
                  },
                  "BankFailure": {
                    "values": {
                      "BANK_FAILURE_DO_NOT_USE": 0,
                      "BANK_FAILURE_OTHER": 1,
                      "BANKING_PARTNER_OUTAGE": 2
                    }
                  },
                  "CardFailure": {
                    "values": {
                      "CARD_FAILURE_DO_NOT_USE": 0,
                      "CARD_FAILURE_OTHER": 1,
                      "CARD_EXPIRED": 2,
                      "CARD_INVALID": 3,
                      "CARD_ISSUER_UNAVAILABLE": 4,
                      "CARD_LIMIT_EXCEEDED": 5,
                      "CARD_INSUFFICIENT_FUNDS": 6,
                      "CARD_SUSPECTED": 7
                    }
                  },
                  "BalanceFailure": {
                    "values": {
                      "BALANCE_FAILURE_DO_NOT_USE": 0,
                      "BALANCE_FAILURE_OTHER": 1,
                      "BALANCE_INCORRECT_DEPOSIT_AMOUNT": 2,
                      "BALANCE_INSUFFICIENT_FUNDS": 3,
                      "BALANCE_LIMIT_EXCEEDED": 4
                    }
                  },
                  "CheckFailure": {
                    "values": {
                      "CHECK_FAILURE_DO_NOT_USE": 0,
                      "CHECK_FAILURE_OTHER": 1
                    }
                  },
                  "failure_reason": {
                    "oneof": ["internalFailure", "eligibilityBlocker", "bankFailure", "cardFailure", "balanceFailure", "checkFailure"]
                  }
                }
              }
            }
          },
          "SweepFailureReason": {
            "fields": {
              "tellerReturnReason": {
                "type": ".squareup.teller.ReturnReason",
                "id": 13,
                "rule": "optional"
              },
              "printableCheckStopCause": {
                "type": ".squareup.checkbook.data.PrintableCheckStopCause",
                "id": 14,
                "rule": "optional"
              },
              "flattenedFailureReason": {
                "type": ".squareup.deposits.SweepFailureReason.FlattenedFailureReason",
                "id": 15,
                "rule": "repeated"
              },
              "esperantoFailure": {
                "type": ".squareup.payments.pushmoney.PushMoneyError",
                "id": 1
              },
              "tellerFailure": {
                "type": ".squareup.teller.FailureReason",
                "id": 2
              },
              "bookkeeperPullFailure": {
                "type": ".squareup.ledger.bookkeeper.SweepBizbankMoneyResponse.Error",
                "id": 3
              },
              "bookkeeperPushFailure": {
                "type": ".squareup.ledger.bookkeeper.ReverseSweepBizbankMoneyResponse.Error",
                "id": 4
              },
              "walletPullFailure": {
                "type": ".squareup.connect.v2.resources.Error.Code",
                "id": 5
              },
              "bankcBalanceChangeAttemptResult": {
                "type": ".squareup.bankc.BalanceChangeAttemptResult",
                "id": 7
              },
              "ledgerPullEligibilityBlocker": {
                "type": ".squareup.ledger.service.EligibilityBlocker",
                "id": 8
              },
              "ledgerPullMoneyMovingBlocker": {
                "type": ".squareup.ledger.service.MoneyMovingBlocker",
                "id": 9
              },
              "pagoError": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 11
              },
              "sweeperError": {
                "type": ".squareup.deposits.SweepFailureReason.SweeperError",
                "id": 10
              },
              "checkbookError": {
                "type": ".squareup.deposits.SweepFailureReason.CheckbookError",
                "id": 12
              }
            },
            "nested": {
              "SweeperError": {
                "values": {
                  "UNKNOWN_SWEEPER_ERROR_DO_NOT_USE": 0,
                  "INVALID_SWEEP_REQUEST_DATA": 1
                }
              },
              "CheckbookError": {
                "fields": {
                  "message": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "FlattenedFailureReason": {
                "fields": {
                  "code": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "detail": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.deposits.SweepFailureReason.FlattenedFailureReason.FailureReasonType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "partnerErrorCode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "FailureReasonType": {
                    "values": {
                      "UNKNOWN_FAILURE_REASON_ORIGIN": 0,
                      "ESPERANTO": 1,
                      "TELLER": 2,
                      "BOOKKEEPER_PULL_FAILURE": 3,
                      "BOOKKEEPER_PUSH_FAILURE": 4,
                      "BANKC_BALANCE_CHANGE_ATTEMPT_RESULT": 5,
                      "LEDGER_PULL_ELIGIBILITY_BLOCKER": 6,
                      "LEDGER_PULL_MONEY_MOVING_BLOCKER": 7,
                      "PAGO_ERROR": 8,
                      "INTERNAL_SWEEPER_ERROR": 9,
                      "CHECKBOOK_ERROR": 10,
                      "PRINTABLE_CHECK_STOP_CAUSE": 11,
                      "TELLER_RETURN": 12
                    }
                  }
                }
              },
              "failure_reason": {
                "oneof": ["esperantoFailure", "tellerFailure", "bookkeeperPullFailure", "bookkeeperPushFailure", "walletPullFailure", "bankcBalanceChangeAttemptResult", "ledgerPullEligibilityBlocker", "ledgerPullMoneyMovingBlocker", "pagoError", "sweeperError", "checkbookError"]
              }
            }
          },
          "BalanceType": {
            "values": {
              "UNKNOWN_BALANCE_TYPE_DO_NOT_USE": 0,
              "NO_STORED_BALANCE": 1,
              "SQUARE_CARD": 2,
              "MANUAL_SETTLEMENT": 3,
              "SAVINGS_ACCOUNT": 4,
              "FOLDERS_ACCOUNT": 5
            }
          },
          "RecurringTransferAmountConfiguration": {
            "fields": {
              "fixedAmount": {
                "type": ".squareup.common.Money",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RecurrenceRule": {
            "fields": {
              "dailySchedule": {
                "type": ".squareup.deposits.RecurrenceRule.DailySchedule",
                "id": 1
              },
              "weeklySchedule": {
                "type": ".squareup.deposits.RecurrenceRule.WeeklySchedule",
                "id": 2
              },
              "monthlySchedule": {
                "type": ".squareup.deposits.RecurrenceRule.MonthlySchedule",
                "id": 3
              }
            },
            "nested": {
              "DailySchedule": {
                "fields": {}
              },
              "WeeklySchedule": {
                "fields": {
                  "dayOfWeek": {
                    "type": ".squareup.common.time.DayOfWeek",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "MonthlySchedule": {
                "fields": {
                  "dayOfMonth": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "recurrence": {
                "oneof": ["dailySchedule", "weeklySchedule", "monthlySchedule"]
              }
            }
          },
          "ConfigurationStatus": {
            "values": {
              "UNKNOWN_CONFIGURATION_STATUS_DO_NOT_USE": 0,
              "ENABLED": 1,
              "DISABLED": 2
            }
          },
          "RecurringTransferMetadata": {
            "fields": {
              "scheduleId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "amountConfiguration": {
                "type": ".squareup.deposits.RecurringTransferAmountConfiguration",
                "id": 2,
                "rule": "optional"
              },
              "recurrenceRule": {
                "type": ".squareup.deposits.RecurrenceRule",
                "id": 3,
                "rule": "optional"
              },
              "status": {
                "type": ".squareup.deposits.ConfigurationStatus",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "RecurringTransferStatus": {
            "values": {
              "UNKNOWN_RECURRING_TRANSFER_STATUS_DO_NOT_USE": 0,
              "SCHEDULED": 1,
              "PROCESSING": 2
            }
          },
          "TransferMetadata": {
            "fields": {
              "feeDestinationUnitToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "memo": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "taxOnFeeAmount": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "taxOnFeeBasisPoints": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "statementDescription": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "transferClientIdempotenceKey": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "applyFeeRateToWithdrawalAmount": {
                "type": "bool",
                "id": 7,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "withdrawalAmount": {
                "type": ".squareup.common.Money",
                "id": 8,
                "rule": "optional"
              },
              "billId": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "recurringTransferScheduleId": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "recurringTransferMetadata": {
                "type": ".squareup.deposits.RecurringTransferMetadata",
                "id": 11,
                "rule": "optional"
              },
              "invoiceToken": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "ledgerBankSettlementEntryToken": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "outageWindowImpact": {
                "type": ".squareup.deposits.TransferOutageWindowImpact",
                "id": 14,
                "rule": "optional"
              }
            }
          },
          "TransferOutageWindowImpact": {
            "fields": {
              "enqueuedDuringMaintenance": {
                "type": ".squareup.deposits.TransferOutageWindowImpact.EnqueuedDuringMaintenance",
                "id": 1
              }
            },
            "nested": {
              "EnqueuedDuringMaintenance": {
                "fields": {
                  "enqueuedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 1,
                    "rule": "optional"
                  },
                  "windowStart": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "windowEnd": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "impact": {
                "oneof": ["enqueuedDuringMaintenance"]
              }
            }
          },
          "SweepData": {
            "fields": {
              "requestIdempotencyToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "resultToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "result": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "failureReason": {
                "type": ".squareup.deposits.SweepFailureReason",
                "id": 4,
                "rule": "optional"
              },
              "startedAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              },
              "entityType": {
                "type": ".squareup.deposits.BalanceActivityEntityType",
                "id": 6,
                "rule": "optional"
              }
            }
          },
          "AuthorityToken": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "authorityType": {
                "type": ".squareup.deposits.AuthorityToken.AuthorityType",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "AuthorityType": {
                "values": {
                  "UNKNOWN_AUTHORITY_TYPE_DO_NOT_USE": 0,
                  "UNIT": 1,
                  "MERCHANT": 2
                }
              }
            }
          },
          "BalanceOwnershipType": {
            "values": {
              "UNKNOWN_BALANCE_OWNERSHIP_TYPE_DO_NOT_USE": 0,
              "MERCHANT": 1,
              "UNIT": 2
            }
          },
          "BalanceOwnershipToken": {
            "fields": {
              "type": {
                "type": ".squareup.deposits.BalanceOwnershipType",
                "id": 1,
                "rule": "optional"
              },
              "token": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.deposits?.nested?.EligibilityBlocker && !$root.nested?.squareup?.nested?.deposits?.nested?.Balance && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityType && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityEntityIdentifier && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityEntityIdentifier?.nested?.IssuedCheck && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityEntityIdentifier?.nested?.PendingEntity && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityEntityView && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityEntityType && !$root.nested?.squareup?.nested?.deposits?.nested?.InstrumentView && !$root.nested?.squareup?.nested?.deposits?.nested?.InstrumentView?.nested?.CardSummary && !$root.nested?.squareup?.nested?.deposits?.nested?.InstrumentView?.nested?.BankAccountSummary && !$root.nested?.squareup?.nested?.deposits?.nested?.InstrumentView?.nested?.CheckSummary && !$root.nested?.squareup?.nested?.deposits?.nested?.InstrumentView?.nested?.IssuedCheckSummary && !$root.nested?.squareup?.nested?.deposits?.nested?.TransferBankAccountEntity && !$root.nested?.squareup?.nested?.deposits?.nested?.TransferCardEntity && !$root.nested?.squareup?.nested?.deposits?.nested?.AvailableBankAction && !$root.nested?.squareup?.nested?.deposits?.nested?.AvailableCardAction && !$root.nested?.squareup?.nested?.deposits?.nested?.AvailableInstrumentAction && !$root.nested?.squareup?.nested?.deposits?.nested?.TransferEntityVerificationState && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivity && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivity?.nested?.State && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityEntryType && !$root.nested?.squareup?.nested?.deposits?.nested?.ExternalTransferTraceInfo && !$root.nested?.squareup?.nested?.deposits?.nested?.ExternalTransferTraceInfo?.nested?.TraceInfoType && !$root.nested?.squareup?.nested?.deposits?.nested?.CheckMetadata && !$root.nested?.squareup?.nested?.deposits?.nested?.CheckMetadata?.nested?.CheckTransferOutMetadata && !$root.nested?.squareup?.nested?.deposits?.nested?.CheckMetadata?.nested?.CheckTransferInMetadata && !$root.nested?.squareup?.nested?.deposits?.nested?.CheckMetadata?.nested?.CheckTransferInMetadata?.nested?.PartialFundingMetadata && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityFailureMetadata && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityFailure && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityFailure?.nested?.TransferFailure && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityFailure?.nested?.TransferFailure?.nested?.InternalFailure && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityFailure?.nested?.TransferFailure?.nested?.BankFailure && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityFailure?.nested?.TransferFailure?.nested?.CardFailure && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityFailure?.nested?.TransferFailure?.nested?.BalanceFailure && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceActivityFailure?.nested?.TransferFailure?.nested?.CheckFailure && !$root.nested?.squareup?.nested?.deposits?.nested?.SweepFailureReason && !$root.nested?.squareup?.nested?.deposits?.nested?.SweepFailureReason?.nested?.SweeperError && !$root.nested?.squareup?.nested?.deposits?.nested?.SweepFailureReason?.nested?.CheckbookError && !$root.nested?.squareup?.nested?.deposits?.nested?.SweepFailureReason?.nested?.FlattenedFailureReason && !$root.nested?.squareup?.nested?.deposits?.nested?.SweepFailureReason?.nested?.FlattenedFailureReason?.nested?.FailureReasonType && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceType && !$root.nested?.squareup?.nested?.deposits?.nested?.RecurringTransferAmountConfiguration && !$root.nested?.squareup?.nested?.deposits?.nested?.RecurrenceRule && !$root.nested?.squareup?.nested?.deposits?.nested?.RecurrenceRule?.nested?.DailySchedule && !$root.nested?.squareup?.nested?.deposits?.nested?.RecurrenceRule?.nested?.WeeklySchedule && !$root.nested?.squareup?.nested?.deposits?.nested?.RecurrenceRule?.nested?.MonthlySchedule && !$root.nested?.squareup?.nested?.deposits?.nested?.ConfigurationStatus && !$root.nested?.squareup?.nested?.deposits?.nested?.RecurringTransferMetadata && !$root.nested?.squareup?.nested?.deposits?.nested?.RecurringTransferStatus && !$root.nested?.squareup?.nested?.deposits?.nested?.TransferMetadata && !$root.nested?.squareup?.nested?.deposits?.nested?.TransferOutageWindowImpact && !$root.nested?.squareup?.nested?.deposits?.nested?.TransferOutageWindowImpact?.nested?.EnqueuedDuringMaintenance && !$root.nested?.squareup?.nested?.deposits?.nested?.SweepData && !$root.nested?.squareup?.nested?.deposits?.nested?.AuthorityToken && !$root.nested?.squareup?.nested?.deposits?.nested?.AuthorityToken?.nested?.AuthorityType && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceOwnershipType && !$root.nested?.squareup?.nested?.deposits?.nested?.BalanceOwnershipToken) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE EligibilityBlocker @ squareup/deposits/model.proto at 26:1
 */
export const EligibilityBlocker = $root.lookupEnum('squareup.deposits.EligibilityBlocker').values;
/**
 * General reified balance representation. This object should contain the "stateless" general bits
 * of information (e.g. balance type, balance ID, light ownership information) that can then be
 * combined along with point-in-time queries about the balance that can then be used to assemble
 * a complete view of the balance at a point in time.
 *
 * SOURCE Balance @ squareup/deposits/model.proto at 105:1
 */
export const Balance = $root.lookupType('squareup.deposits.Balance');
fixType(Balance);
Builder.createAndAttachToType(Balance);
/**
 * Represents the possible kind of activity on a balance.
 *
 * SOURCE BalanceActivityType @ squareup/deposits/model.proto at 114:1
 */
export const BalanceActivityType = $root.lookupEnum('squareup.deposits.BalanceActivityType').values;
/**
 * Represents the source or destination of a balance activity used in requests.
 *
 * SOURCE BalanceActivityEntityIdentifier @ squareup/deposits/model.proto at 135:1
 */
export const BalanceActivityEntityIdentifier = $root.lookupType('squareup.deposits.BalanceActivityEntityIdentifier');
fixType(BalanceActivityEntityIdentifier);
Builder.createAndAttachToType(BalanceActivityEntityIdentifier);
/**
 * A check to issue through Checkbook
 * This is only supported in the synchronous CreateTransfer flow where source is a banklin
 * balance. Billpay uses Pending destinations until the vendor selects one, and then calls
 * UpdatePendingTransfer to set that destination. If the selected destination is a check, this
 * should be included to indicate information about that check.
 *
 * SOURCE IssuedCheck @ squareup/deposits/model.proto at 143:3
 */
BalanceActivityEntityIdentifier.IssuedCheck = $root.lookupType('squareup.deposits.BalanceActivityEntityIdentifier.IssuedCheck');
fixType(BalanceActivityEntityIdentifier.IssuedCheck);
Builder.createAndAttachToType(BalanceActivityEntityIdentifier.IssuedCheck);
/**
 * A destination with this type will be ignored, and the transfer will pause until it is
 * overwritten with a real destination.
 *
 * SOURCE PendingEntity @ squareup/deposits/model.proto at 158:3
 */
BalanceActivityEntityIdentifier.PendingEntity = $root.lookupType('squareup.deposits.BalanceActivityEntityIdentifier.PendingEntity');
fixType(BalanceActivityEntityIdentifier.PendingEntity);
Builder.createAndAttachToType(BalanceActivityEntityIdentifier.PendingEntity);
/**
 * Represents a more detailed source or destination of a balance activity used in responses.
 *
 * SOURCE BalanceActivityEntityView @ squareup/deposits/model.proto at 192:1
 */
export const BalanceActivityEntityView = $root.lookupType('squareup.deposits.BalanceActivityEntityView');
fixType(BalanceActivityEntityView);
Builder.createAndAttachToType(BalanceActivityEntityView);
/**
 * Represents the type of entity used as the source/destination of a balance activity.
 *
 * SOURCE BalanceActivityEntityType @ squareup/deposits/model.proto at 206:1
 */
export const BalanceActivityEntityType = $root.lookupEnum('squareup.deposits.BalanceActivityEntityType').values;
/**
 * SOURCE InstrumentView @ squareup/deposits/model.proto at 222:1
 */
export const InstrumentView = $root.lookupType('squareup.deposits.InstrumentView');
fixType(InstrumentView);
Builder.createAndAttachToType(InstrumentView);
/**
 * SOURCE CardSummary @ squareup/deposits/model.proto at 251:3
 */
InstrumentView.CardSummary = $root.lookupType('squareup.deposits.InstrumentView.CardSummary');
fixType(InstrumentView.CardSummary);
Builder.createAndAttachToType(InstrumentView.CardSummary);
/**
 * SOURCE BankAccountSummary @ squareup/deposits/model.proto at 262:3
 */
InstrumentView.BankAccountSummary = $root.lookupType('squareup.deposits.InstrumentView.BankAccountSummary');
fixType(InstrumentView.BankAccountSummary);
Builder.createAndAttachToType(InstrumentView.BankAccountSummary);
/**
 * SOURCE CheckSummary @ squareup/deposits/model.proto at 273:3
 */
InstrumentView.CheckSummary = $root.lookupType('squareup.deposits.InstrumentView.CheckSummary');
fixType(InstrumentView.CheckSummary);
Builder.createAndAttachToType(InstrumentView.CheckSummary);
/**
 * SOURCE IssuedCheckSummary @ squareup/deposits/model.proto at 277:3
 */
InstrumentView.IssuedCheckSummary = $root.lookupType('squareup.deposits.InstrumentView.IssuedCheckSummary');
fixType(InstrumentView.IssuedCheckSummary);
Builder.createAndAttachToType(InstrumentView.IssuedCheckSummary);
/**
 * SOURCE TransferBankAccountEntity @ squareup/deposits/model.proto at 285:1
 */
export const TransferBankAccountEntity = $root.lookupType('squareup.deposits.TransferBankAccountEntity');
fixType(TransferBankAccountEntity, {
  instrumentToken: {
    notEmpty: true
  },
  accountNumberSuffix: {
    notEmpty: true
  },
  encodedSqwebBankToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferBankAccountEntity);
/**
 * SOURCE TransferCardEntity @ squareup/deposits/model.proto at 297:1
 */
export const TransferCardEntity = $root.lookupType('squareup.deposits.TransferCardEntity');
fixType(TransferCardEntity, {
  instrumentToken: {
    notEmpty: true
  },
  panSuffix: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferCardEntity);
/**
 * SOURCE AvailableBankAction @ squareup/deposits/model.proto at 306:1
 */
export const AvailableBankAction = $root.lookupEnum('squareup.deposits.AvailableBankAction').values;
/**
 * SOURCE AvailableCardAction @ squareup/deposits/model.proto at 310:1
 */
export const AvailableCardAction = $root.lookupEnum('squareup.deposits.AvailableCardAction').values;
/**
 * SOURCE AvailableInstrumentAction @ squareup/deposits/model.proto at 315:1
 */
export const AvailableInstrumentAction = $root.lookupEnum('squareup.deposits.AvailableInstrumentAction').values;
/**
 * SOURCE TransferEntityVerificationState @ squareup/deposits/model.proto at 323:1
 */
export const TransferEntityVerificationState = $root.lookupEnum('squareup.deposits.TransferEntityVerificationState').values;
/**
 * SOURCE BalanceActivity @ squareup/deposits/model.proto at 333:1
 */
export const BalanceActivity = $root.lookupType('squareup.deposits.BalanceActivity');
fixType(BalanceActivity, {
  source: {
    required: true
  },
  destination: {
    required: true
  },
  amount: {
    required: true
  },
  feeAmount: {
    required: true
  }
});
Builder.createAndAttachToType(BalanceActivity);
/**
 * SOURCE State @ squareup/deposits/model.proto at 365:3
 */
BalanceActivity.State = $root.lookupEnum('squareup.deposits.BalanceActivity.State').values;
/**
 * SOURCE BalanceActivityEntryType @ squareup/deposits/model.proto at 437:1
 */
export const BalanceActivityEntryType = $root.lookupEnum('squareup.deposits.BalanceActivityEntryType').values;
/**
 * The external transfer trace info.
 * For standard speed transfer to bank account, the ACH trace number and the customer ID,
 * which is renamed to the transmission id.
 * For IT/SDT to bank account, the End-to-End ID.
 * For IT/SDT to card, the ARN / RRN number.
 *
 * SOURCE ExternalTransferTraceInfo @ squareup/deposits/model.proto at 450:1
 */
export const ExternalTransferTraceInfo = $root.lookupType('squareup.deposits.ExternalTransferTraceInfo');
fixType(ExternalTransferTraceInfo);
Builder.createAndAttachToType(ExternalTransferTraceInfo);
/**
 * SOURCE TraceInfoType @ squareup/deposits/model.proto at 451:3
 */
ExternalTransferTraceInfo.TraceInfoType = $root.lookupEnum('squareup.deposits.ExternalTransferTraceInfo.TraceInfoType').values;
/**
 * SOURCE CheckMetadata @ squareup/deposits/model.proto at 473:1
 */
export const CheckMetadata = $root.lookupType('squareup.deposits.CheckMetadata');
fixType(CheckMetadata);
Builder.createAndAttachToType(CheckMetadata);
/**
 * SOURCE CheckTransferOutMetadata @ squareup/deposits/model.proto at 474:3
 */
CheckMetadata.CheckTransferOutMetadata = $root.lookupType('squareup.deposits.CheckMetadata.CheckTransferOutMetadata');
fixType(CheckMetadata.CheckTransferOutMetadata);
Builder.createAndAttachToType(CheckMetadata.CheckTransferOutMetadata);
/**
 * SOURCE CheckTransferInMetadata @ squareup/deposits/model.proto at 488:3
 */
CheckMetadata.CheckTransferInMetadata = $root.lookupType('squareup.deposits.CheckMetadata.CheckTransferInMetadata');
fixType(CheckMetadata.CheckTransferInMetadata);
Builder.createAndAttachToType(CheckMetadata.CheckTransferInMetadata);
/**
 * SOURCE PartialFundingMetadata @ squareup/deposits/model.proto at 489:5
 */
CheckMetadata.CheckTransferInMetadata.PartialFundingMetadata = $root.lookupType('squareup.deposits.CheckMetadata.CheckTransferInMetadata.PartialFundingMetadata');
fixType(CheckMetadata.CheckTransferInMetadata.PartialFundingMetadata);
Builder.createAndAttachToType(CheckMetadata.CheckTransferInMetadata.PartialFundingMetadata);
/**
 * SOURCE BalanceActivityFailureMetadata @ squareup/deposits/model.proto at 524:1
 */
export const BalanceActivityFailureMetadata = $root.lookupType('squareup.deposits.BalanceActivityFailureMetadata');
fixType(BalanceActivityFailureMetadata);
Builder.createAndAttachToType(BalanceActivityFailureMetadata);
/**
 * SOURCE BalanceActivityFailure @ squareup/deposits/model.proto at 532:1
 */
export const BalanceActivityFailure = $root.lookupType('squareup.deposits.BalanceActivityFailure');
fixType(BalanceActivityFailure);
Builder.createAndAttachToType(BalanceActivityFailure);
/**
 * SOURCE TransferFailure @ squareup/deposits/model.proto at 557:3
 */
BalanceActivityFailure.TransferFailure = $root.lookupType('squareup.deposits.BalanceActivityFailure.TransferFailure');
fixType(BalanceActivityFailure.TransferFailure);
Builder.createAndAttachToType(BalanceActivityFailure.TransferFailure);
/**
 * SOURCE InternalFailure @ squareup/deposits/model.proto at 578:5
 */
BalanceActivityFailure.TransferFailure.InternalFailure = $root.lookupEnum('squareup.deposits.BalanceActivityFailure.TransferFailure.InternalFailure').values;
/**
 * SOURCE BankFailure @ squareup/deposits/model.proto at 588:5
 */
BalanceActivityFailure.TransferFailure.BankFailure = $root.lookupEnum('squareup.deposits.BalanceActivityFailure.TransferFailure.BankFailure').values;
/**
 * SOURCE CardFailure @ squareup/deposits/model.proto at 594:5
 */
BalanceActivityFailure.TransferFailure.CardFailure = $root.lookupEnum('squareup.deposits.BalanceActivityFailure.TransferFailure.CardFailure').values;
/**
 * SOURCE BalanceFailure @ squareup/deposits/model.proto at 606:5
 */
BalanceActivityFailure.TransferFailure.BalanceFailure = $root.lookupEnum('squareup.deposits.BalanceActivityFailure.TransferFailure.BalanceFailure').values;
/**
 * SOURCE CheckFailure @ squareup/deposits/model.proto at 614:5
 */
BalanceActivityFailure.TransferFailure.CheckFailure = $root.lookupEnum('squareup.deposits.BalanceActivityFailure.TransferFailure.CheckFailure').values;
/**
 * Represents the failure reason for the sweep.
 *
 * SOURCE SweepFailureReason @ squareup/deposits/model.proto at 634:1
 */
export const SweepFailureReason = $root.lookupType('squareup.deposits.SweepFailureReason');
fixType(SweepFailureReason);
Builder.createAndAttachToType(SweepFailureReason);
/**
 * SOURCE SweeperError @ squareup/deposits/model.proto at 635:3
 */
SweepFailureReason.SweeperError = $root.lookupEnum('squareup.deposits.SweepFailureReason.SweeperError').values;
/**
 * SOURCE CheckbookError @ squareup/deposits/model.proto at 645:3
 */
SweepFailureReason.CheckbookError = $root.lookupType('squareup.deposits.SweepFailureReason.CheckbookError');
fixType(SweepFailureReason.CheckbookError);
Builder.createAndAttachToType(SweepFailureReason.CheckbookError);
/**
 * SOURCE FlattenedFailureReason @ squareup/deposits/model.proto at 694:3
 */
SweepFailureReason.FlattenedFailureReason = $root.lookupType('squareup.deposits.SweepFailureReason.FlattenedFailureReason');
fixType(SweepFailureReason.FlattenedFailureReason, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(SweepFailureReason.FlattenedFailureReason);
/**
 * SOURCE FailureReasonType @ squareup/deposits/model.proto at 700:5
 */
SweepFailureReason.FlattenedFailureReason.FailureReasonType = $root.lookupEnum('squareup.deposits.SweepFailureReason.FlattenedFailureReason.FailureReasonType').values;
/**
 * Represents the type of balance, named deliberately to associate the balance to the settlement
 * style rather than the backing store.
 *
 * SOURCE BalanceType @ squareup/deposits/model.proto at 721:1
 */
export const BalanceType = $root.lookupEnum('squareup.deposits.BalanceType').values;
/**
 * Amount configurations
 *
 * SOURCE RecurringTransferAmountConfiguration @ squareup/deposits/model.proto at 759:1
 */
export const RecurringTransferAmountConfiguration = $root.lookupType('squareup.deposits.RecurringTransferAmountConfiguration');
fixType(RecurringTransferAmountConfiguration, {
  fixedAmount: {
    required: true
  }
});
Builder.createAndAttachToType(RecurringTransferAmountConfiguration);
/**
 * Recurrence configurations
 *
 * SOURCE RecurrenceRule @ squareup/deposits/model.proto at 764:1
 */
export const RecurrenceRule = $root.lookupType('squareup.deposits.RecurrenceRule');
fixType(RecurrenceRule);
Builder.createAndAttachToType(RecurrenceRule);
/**
 * SOURCE DailySchedule @ squareup/deposits/model.proto at 771:3
 */
RecurrenceRule.DailySchedule = $root.lookupType('squareup.deposits.RecurrenceRule.DailySchedule');
fixType(RecurrenceRule.DailySchedule);
Builder.createAndAttachToType(RecurrenceRule.DailySchedule);
/**
 * SOURCE WeeklySchedule @ squareup/deposits/model.proto at 773:3
 */
RecurrenceRule.WeeklySchedule = $root.lookupType('squareup.deposits.RecurrenceRule.WeeklySchedule');
fixType(RecurrenceRule.WeeklySchedule, {
  dayOfWeek: {
    required: true
  }
});
Builder.createAndAttachToType(RecurrenceRule.WeeklySchedule);
/**
 * Represents a static monthly configuration for a schedule. If this static value isn't present in
 * a given month, the transfer will happen on the last day of that month, and that specific
 * date can be found in the settlement_time_utc field on the ScheduledTransfer.
 *
 * SOURCE MonthlySchedule @ squareup/deposits/model.proto at 782:3
 */
RecurrenceRule.MonthlySchedule = $root.lookupType('squareup.deposits.RecurrenceRule.MonthlySchedule');
fixType(RecurrenceRule.MonthlySchedule);
Builder.createAndAttachToType(RecurrenceRule.MonthlySchedule);
/**
 * SOURCE ConfigurationStatus @ squareup/deposits/model.proto at 788:1
 */
export const ConfigurationStatus = $root.lookupEnum('squareup.deposits.ConfigurationStatus').values;
/**
 * SOURCE RecurringTransferMetadata @ squareup/deposits/model.proto at 794:1
 */
export const RecurringTransferMetadata = $root.lookupType('squareup.deposits.RecurringTransferMetadata');
fixType(RecurringTransferMetadata);
Builder.createAndAttachToType(RecurringTransferMetadata);
/**
 * SOURCE RecurringTransferStatus @ squareup/deposits/model.proto at 801:1
 */
export const RecurringTransferStatus = $root.lookupEnum('squareup.deposits.RecurringTransferStatus').values;
/**
 * SOURCE TransferMetadata @ squareup/deposits/model.proto at 807:1
 */
export const TransferMetadata = $root.lookupType('squareup.deposits.TransferMetadata');
fixType(TransferMetadata);
Builder.createAndAttachToType(TransferMetadata);
/**
 * SOURCE TransferOutageWindowImpact @ squareup/deposits/model.proto at 862:1
 */
export const TransferOutageWindowImpact = $root.lookupType('squareup.deposits.TransferOutageWindowImpact');
fixType(TransferOutageWindowImpact);
Builder.createAndAttachToType(TransferOutageWindowImpact);
/**
 * SOURCE EnqueuedDuringMaintenance @ squareup/deposits/model.proto at 863:3
 */
TransferOutageWindowImpact.EnqueuedDuringMaintenance = $root.lookupType('squareup.deposits.TransferOutageWindowImpact.EnqueuedDuringMaintenance');
fixType(TransferOutageWindowImpact.EnqueuedDuringMaintenance, {
  enqueuedAt: {
    required: true
  },
  windowStart: {
    required: true
  },
  windowEnd: {
    required: true
  }
});
Builder.createAndAttachToType(TransferOutageWindowImpact.EnqueuedDuringMaintenance);
/**
 * SOURCE SweepData @ squareup/deposits/model.proto at 874:1
 */
export const SweepData = $root.lookupType('squareup.deposits.SweepData');
fixType(SweepData);
Builder.createAndAttachToType(SweepData);
/**
 * SOURCE AuthorityToken @ squareup/deposits/model.proto at 960:1
 */
export const AuthorityToken = $root.lookupType('squareup.deposits.AuthorityToken');
fixType(AuthorityToken);
Builder.createAndAttachToType(AuthorityToken);
/**
 * SOURCE AuthorityType @ squareup/deposits/model.proto at 964:3
 */
AuthorityToken.AuthorityType = $root.lookupEnum('squareup.deposits.AuthorityToken.AuthorityType').values;
/**
 * SOURCE BalanceOwnershipType @ squareup/deposits/model.proto at 990:1
 */
export const BalanceOwnershipType = $root.lookupEnum('squareup.deposits.BalanceOwnershipType').values;
/**
 * SOURCE BalanceOwnershipToken @ squareup/deposits/model.proto at 996:1
 */
export const BalanceOwnershipToken = $root.lookupType('squareup.deposits.BalanceOwnershipToken');
fixType(BalanceOwnershipToken);
Builder.createAndAttachToType(BalanceOwnershipToken);